import { useForm, UseFormReturn } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

interface UseReactHookFormProps {
  defaultValues?: any;
  values?: any;
  yupSchema?: any;
}

export const useReactHookForm = ({
  defaultValues = undefined,
  values = undefined,
  yupSchema = undefined,
}: UseReactHookFormProps): UseFormReturn => {
  const formContextMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    ...(defaultValues && { defaultValues }),
    ...(values && { values }),
    ...(yupSchema && { resolver: yupResolver(yupSchema) }),
  });
  return formContextMethods;
};
